import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => {
    return {
        container: {
            position: 'fixed',
            width: 0,
            height: 0,
            overflow: 'visible',
            zIndex: 9998
        },
    }
})